// extracted by mini-css-extract-plugin
module.exports = {"size-badge":"FeedbackSizeBadge_size-badge__r_Wrh","small":"FeedbackSizeBadge_small__3UDHM","medium":"FeedbackSizeBadge_medium__2o527","large":"FeedbackSizeBadge_large__19iEy"};